import React, { useState } from "react";
import { useLanguage } from '../i18n';

export default function FlyghinderOrderModal({ open, onClose, onConfirm }) {
  const { t, language } = useLanguage();

  const [company, setCompany] = useState(true);
  const [fields, setFields] = useState({
    companyName: "",
    orgNr: "",
    contactPerson: "",
    email: "",
    property: "",
    phone: "",
    address: "",
    zipcode: "",
    city: "",
  });
  const [accept, setAccept] = useState(false);

  const handleChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const canSubmit =
    fields.email &&
    fields.contactPerson &&
    accept &&
    (company ? fields.companyName && fields.orgNr : true);

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>
          {language === "sv"
            ? "Beställ Flyghinderanalys"
            : "Order Obstacle Analysis"}
        </h2>
        {/* Fastighetsbeteckning och E-postadress på samma rad */}
        <div className="form-row-multi">
          <div style={{ flex: 1 }}>
            <label>
              {language === "sv"
                ? "Fastighetsbeteckning (visas i Flyghinderanalysen)"
                : "Property designation (shown in the Obstacle Analysis)"}
            </label>
            <input
              name="property"
              value={fields.property}
              onChange={handleChange}
              style={{ background: "#e9f5db" }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>
              {language === "sv"
                ? "E-postadress (hit skickas Flyghinderanalysen) *"
                : "Email address (Obstacle Analysis sent here) *"}
            </label>
            <input
              name="email"
              value={fields.email}
              onChange={handleChange}
              required
              style={{ background: "#e9f5db" }}
            />
          </div>
        </div>
        {/* Radioknappar med snygg layout */}
        <div className="form-row-radio">
          <label className="radio-title">
            {language === "sv"
              ? "Beställer du som företag eller privatperson?"
              : "Are you ordering as a company or private individual?"}
          </label>
          <div className="radio-options-horizontal" style={{display:"flex", gap: '16px'}}>
            <label>
              <input
                type="radio"
                name="company"
                checked={company}
                onChange={() => setCompany(true)}
              />
              {language === "sv" ? "Företag" : "Company"}
            </label>
            <label>
              <input
                type="radio"
                name="company"
                checked={!company}
                onChange={() => setCompany(false)}
              />
              {language === "sv" ? "Privatperson" : "Private individual"}
            </label>
          </div>
        </div>
        {/* Företagsfält på en rad */}
        {company && (
          <div className="form-row-multi">
            <div>
              <label>
                {language === "sv" ? "Företagsnamn *" : "Company name *"}
              </label>
              <input
                name="companyName"
                value={fields.companyName}
                onChange={handleChange}
                required
                style={{ background: "#e9f5db" }}
              />
            </div>
            <div>
              <label>
                {language === "sv" ? "Org. nummer *" : "Org. number *"}
              </label>
              <input
                name="orgNr"
                value={fields.orgNr}
                onChange={handleChange}
                required
                style={{ background: "#e9f5db" }}
              />
            </div>
            <div>
              <label>
                {language === "sv" ? "Kontaktperson *" : "Contact person *"}
              </label>
              <input
                name="contactPerson"
                value={fields.contactPerson}
                onChange={handleChange}
                required
                style={{ background: "#e9f5db" }}
              />
            </div>
          </div>
        )}
        {/* Privatperson fält */}
        {!company && (
          <div className="form-row-multi">
            <div>
              <label>
                {language === "sv" ? "Kontaktperson *" : "Contact person *"}
              </label>
              <input
                name="contactPerson"
                value={fields.contactPerson}
                onChange={handleChange}
                required
                style={{ background: "#e9f5db" }}
              />
            </div>
          </div>
        )}
        {/* Telefon/adress/postnummer/postort på en rad */}
        <div className="form-row-multi">
          <div>
            <label>{language === "sv" ? "Telefonnummer" : "Phone"}</label>
            <input
              name="phone"
              value={fields.phone}
              onChange={handleChange}
              style={{ background: "#e9f5db" }}
            />
          </div>
          <div>
            <label>{language === "sv" ? "Adress" : "Address"}</label>
            <input
              name="address"
              value={fields.address}
              onChange={handleChange}
              style={{ background: "#e9f5db" }}
            />
          </div>
          <div>
            <label>{language === "sv" ? "Postnummer" : "Zip code"}</label>
            <input
              name="zipcode"
              value={fields.zipcode}
              onChange={handleChange}
              style={{ background: "#e9f5db" }}
            />
          </div>
          <div>
            <label>{language === "sv" ? "Postort" : "City"}</label>
            <input
              name="city"
              value={fields.city}
              onChange={handleChange}
              style={{ background: "#e9f5db" }}
            />
          </div>
        </div>
        {/* Accepterar GDPR checkbox */}
        <div className="form-row-radio">
          <label className="radio-title" style={{display: "flex", alignItems: "center"}}>
            <input
              type="checkbox"
              name="accept"
              checked={accept}
              onChange={() => setAccept(!accept)}
              style={{marginRight: 8}}
            />
            {language === "sv"
              ? "Jag godkänner webbplatsens användarvillkor och integritetspolicy"
              : "I accept the website's terms of use and privacy policy"}
            <span title={
              language === "sv"
                ? "Information om datalagring, GDPR och ansvarsfriskrivning"
                : "Information about data storage, GDPR and disclaimer"
            } style={{ marginLeft: 8, cursor: "pointer" }}>?</span>
          </label>
        </div>
        <div style={{ marginTop: 16, background: "#f8f8e8", padding: 10, borderRadius: 6, fontSize: 15 }}>
          <b>{language === "sv" ? "Villkor, GDPR & ansvarsfriskrivning" : "Terms, GDPR & Disclaimer"}:</b>
          <ul>
            <li>
              {language === "sv"
                ? "Jag godkänner att de uppgifter jag lämnar i detta formulär – såsom namn, e-postadress, analysdata och IP-adress – sparas av Flightsafe.se i syfte att hantera min användning och möjliggöra effektiv kundservice. Uppgifterna behandlas konfidentiellt och sparas endast så länge det är nödvändigt för ärendets hantering eller enligt gällande lag."
                : "I consent to the information I provide in this form – such as name, email address, analysis data, and IP address – being stored by Flightsafe.se for the purpose of managing my usage and enabling effective customer service. The information is treated confidentially and stored only as long as necessary for handling the case or as required by law."
              }
            </li>
            <li>
              {language === "sv"
  ? <>
      Jag är medveten om att jag kan testa Flightsafe <b>3 gånger utan aktiv prenumeration</b>. 
      Observera att prenumerationen är helt kostnadsfri och utan förpliktelser! 
      Jag kan när som helst begära rättelse eller radering av mina personuppgifter genom att kontakta kundtjänst.
    </>
  : <>
      I am aware that I can try Flightsafe <b>3 times without an active subscription</b>.
      Please note that the subscription is completely free of charge and comes with no obligations!
      I can at any time request correction or deletion of my personal data by contacting customer service.
    </>
}
            </li>
            <li>
              {language === "sv"
                ? "Jag har rätt att få tillgång till de uppgifter som Flightsafe.se har sparat om mig, invända mot behandlingen eller begära begränsning. Jag kan också lämna klagomål till Integritetsskyddsmyndigheten (IMY)."
                : "I have the right to access my stored data, object to the processing, or request restriction. I can also file a complaint with the Swedish Authority for Privacy Protection (IMY)."
              }
            </li>
            <li>
              {language === "sv"
                ? "För frågor kring personuppgiftsbehandling, vänligen kontakta: kundtjanst@flightsafe.se"
                : "For questions regarding data processing, please contact: kundtjanst@flightsafe.se"
              }
            </li>
            <li>
              {language === "sv"
                ? <><b>Ansvarsfriskrivning:</b> Flightsafe.se tar inget ansvar för den information, analys eller de resultat som genereras av programmet. Det är ditt ansvar som användare att noggrant kontrollera såväl den data du matar in som de analyser och resultat som programmet levererar.</>
                : <><b>Disclaimer:</b> Flightsafe.se assumes no responsibility for the information, analyses, or results generated by the program. It is your responsibility as a user to carefully verify both the data you input and the analyses and results provided by the program.</>
              }
            </li>
          </ul>
        </div>
        <div style={{ marginTop: 22, textAlign: "right" }}>
          <button
            onClick={onClose}
            style={{ marginRight: 18 }}
          >
            {language === "sv" ? "Avbryt" : "Cancel"}
          </button>
          <button
            disabled={!canSubmit}
            onClick={() => onConfirm(fields, company)}
            style={{
              background: canSubmit ? "#275dde" : "#aaa",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: 4,
              padding: "8px 24px",
              fontSize: 17,
              border: "none",
              cursor: canSubmit ? "pointer" : "not-allowed"
            }}
          >
            {language === "sv"
              ? "Beställ och skapa Flyghinderanalys"
              : "Order and create Obstacle Analysis"}
          </button>
        </div>
      </div>
      <style>{`
        .modal-overlay {
          position: fixed; left: 0; top: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.25); z-index: 9999; display: flex; align-items: center; justify-content: center;
        }
        .modal-content {
          background: #fff; border-radius: 10px; padding: 36px 32px 26px 32px; box-shadow: 0 4px 32px rgba(0,0,0,0.16); min-width: 900px; max-width: 92vw;
        }
        .form-row-multi {
          margin-bottom: 18px;
          display: flex;
          flex-direction: row;
          gap: 32px;
        }
        .form-row-multi > div {
          flex: 1;
          min-width: 180px;
        }
        .form-row-multi label {
          font-size: 16px;
          margin-bottom: 4px;
          display: block;
        }
        .form-row-multi input {
          font-size: 16px;
          padding: 7px 14px;
          border-radius: 4px;
          border: 1px solid #c8d1c8;
          background: #e9f5db;
          width: 100%;
          box-sizing: border-box;
        }
        .form-row-radio {
          margin-bottom: 18px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .radio-title {
          font-size: 16px;
          margin-bottom: 4px;
        }
        .radio-options, .radio-options-horizontal {
          display: flex;
        }
        .radio-options {
          flex-direction: column;
          gap: 2px;
          margin-left: 12px;
        }
        .radio-options-horizontal {
          flex-direction: row;
          gap: 18px;
          margin-left: 12px;
        }
        .radio-options label, .radio-options-horizontal label {
          font-size: 16px;
        }
        .form-row label {
          min-width: 120px;
          font-size: 16px;
        }
        .form-row input {
          font-size: 16px;
          padding: 6px 8px;
          border-radius: 4px;
          border: 1px solid #c8d1c8;
          min-width: 180px;
        }
      `}</style>
    </div>
  );
}